import api from 'api';
import {usePostApi} from 'common/hooks/usePostApi';
import React from 'react';
import {ILogBuffer} from 'types/diplomat/logs/LogBuffer';
import {ILogView} from 'types/diplomat/logs/LogView';
import {downloadTextFile} from 'common/downloadFile';

export const useDownloadLog = (logView = {} as ILogView, isCloud?: boolean) => {
   const textBufferRef = React.useRef(['']);

   const {request: loadBuffer} = usePostApi<ILogBuffer>(
      isCloud ? api.remoteAgentLogsText : api.logsText,
      {
         onSuccess: (data) => {
            for (let i = 0; i < data.buffer.length; i++) {
               textBufferRef.current[data.lineNumber + i] = data.buffer[i];
            }
         },
      }
   );

   const download = React.useCallback(async () => {
      const {viewId, numLines, bufferSize} = logView;

      const buffersCount = Math.ceil(numLines / bufferSize);
      //   console.debug('download', buffersCount, logView);
      const promises = [];
      for (let i = 0; i < buffersCount; i++) {
         promises.push(
            loadBuffer(
               JSON.stringify({
                  viewId,
                  lineNumber: i * bufferSize,
               })
            )
         );
      }

      await Promise.all(promises);
      const log = textBufferRef.current.join('\n');
      downloadTextFile(log, viewId);
   }, [loadBuffer, logView, textBufferRef]);

   return download;
};
